import {
    CLEAR_ERROR_MESSAGE_PAYMENT
} from '../constants'

export function reducer(state, action) {
    if (action.type === CLEAR_ERROR_MESSAGE_PAYMENT) {
        return {...state, errorMessagePayment: false}
    } else {
        return state
    }
}